export type NotificationPermissionState =
  | NotificationPermission
  | "unsupported";

export interface NotificationPermissionAdapter {
  getState: () => NotificationPermissionState;
  request: () => Promise<NotificationPermissionState>;
  subscribe: (listener: (state: NotificationPermissionState) => void) => () => void;
}

function readState(): NotificationPermissionState {
  if (typeof window.Notification === "undefined") {
    return "unsupported";
  }

  return window.Notification.permission;
}

export const browserNotificationPermission: NotificationPermissionAdapter = {
  getState: readState,

  async request() {
    if (typeof window.Notification === "undefined") {
      return "unsupported";
    }

    return window.Notification.requestPermission();
  },

  subscribe(listener) {
    if (typeof window.Notification === "undefined") {
      return () => undefined;
    }

    const notify = () => listener(readState());
    window.addEventListener("focus", notify);

    let permissionStatus: PermissionStatus | null = null;
    let active = true;

    if ("permissions" in navigator) {
      void navigator.permissions
        .query({ name: "notifications" as PermissionName })
        .then((status) => {
          if (!active) {
            return;
          }
          permissionStatus = status;
          permissionStatus.addEventListener("change", notify);
          notify();
        })
        .catch(() => {
          // Notification.permission remains the compatibility fallback.
        });
    }

    return () => {
      active = false;
      window.removeEventListener("focus", notify);
      permissionStatus?.removeEventListener("change", notify);
    };
  },
};
